import NextImage from "next/image";

export type ReportPreviewHeroProps = {
  alt: string;
  mobileSrc: string;
  desktopSrc: string;
};

export const ReportPreviewHero: React.FC<ReportPreviewHeroProps> = ({
  alt,
  desktopSrc,
  mobileSrc,
}) => (
  <>
    <NextImage
      alt={alt}
      className="z-10 hidden max-h-full min-h-[525px] object-cover object-right lg:block"
      src={desktopSrc}
      quality={100}
      fill
    />

    <div className="relative z-10 size-full min-h-[190px] lg:hidden">
      <NextImage
        alt={alt}
        className="max-h-full object-cover object-top"
        src={mobileSrc}
        quality={100}
        fill
      />
    </div>
  </>
);
